import React, { useRef, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import useScroll from "../../hooks/useScroll";
import { sortLeaguesData } from "../../utils/listUtils";

/**
 *
 * SportsMenu - common component use for menu tabs.
 *
 */

const SportsMenu = ({ data, handleSelect, selectedItem, isFixedMenu }) => {
  const isLoading = data !== undefined ? false : true;
  const mergedObj = sortLeaguesData(data, isFixedMenu)

  const containerRef = useRef(null);
  const selectedRef = useRef(null);
  useScroll(containerRef);

  // hooks create for scroll selected element to left
  useEffect(() => {
    if (containerRef.current && selectedRef.current) {
      const container = containerRef.current;
      const selected = selectedRef.current;

      const containerRect = container.getBoundingClientRect();
      const selectedRect = selected.getBoundingClientRect();

      const scrollOffset = selectedRect.left - containerRect.left - 14;
      container.scrollTo({
        behavior: "smooth",
        left: container.scrollLeft + scrollOffset,
      });
    }
    // eslint-disable-next-line
  }, [selectedItem, containerRef.current, selectedRef.current]);

  return (
    <div className="league_tabs">
      <div
        className={
          isLoading ? "league_tab_slider loading" : "league_tab_slider"
        }
      >
        <ul ref={containerRef} data-scrollable="true">
          {isLoading
            ? Array.from({ length: mergedObj?.length || 5 }).map((_, index) => (
                <li key={index} className="league_tab_slider_item">
                  <Skeleton height={100} />
                </li>
              ))
            : mergedObj?.map((key) => (
                <li
                  key={key}
                  ref={selectedItem === key ? selectedRef : null}
                  className={selectedItem === key ? "selected" : null}
                  onClick={() => handleSelect(key)}
                >
                  {data[key]}
                </li>
              ))}
        </ul>
      </div>
    </div>
  );
};

export default SportsMenu;
